/* start - flights_split_bounds_us */
import { WishlistWidgetLoader } from "components/remote";
import useAlternativeFaresParams from "hooks/useAlternativeFaresParams";
import useClientCachedURL from "hooks/useClientCachedURL";
import useProfiler from "hooks/useProfiler";
import React, { ReactNode } from "react";
import { useParams } from "react-router-dom";
import { SearchPaginationDesktop } from "../SearchPagination";
import RefreshResults from "./components/RefreshResults";
import { UIFlightData } from "@flights/types";
import { trackWithDefaultStage } from "@flights/et-universal";

type Props = {
  flights: UIFlightData[];
  fetchedAt: any;
  children: ReactNode;
};

const SearchResultsContentDesktop = ({ children, flights, fetchedAt }: Props) => {
  const { airports } = useParams<{ airports: string }>();

  const { cacheLastSuccessfulSearchUrl } = useClientCachedURL();
  const { setAlternativeFaresParams } = useAlternativeFaresParams();
  const { isLoggedIn } = useProfiler();

  cacheLastSuccessfulSearchUrl(airports);
  fetchedAt && setAlternativeFaresParams("searchedAt", fetchedAt);

  return (
    <>
      {children}
      <SearchPaginationDesktop />
      <RefreshResults flights={flights} />
      {isLoggedIn() && !!trackWithDefaultStage("ddot_wl_save_flights", 9) ? <WishlistWidgetLoader /> : null}
    </>
  );
};

export default SearchResultsContentDesktop;
/* end - flights_split_bounds_us */
